export function deleteInvitation (state, invitationId) {
	const i = state.invitations.findIndex(invitation => invitation.id === invitationId);

	if (i >= 0) state.invitations.splice(i, 1);
}
